<template>
  <div class="appBody bg-white" style="height: auto" v-if="currentAdvSub">
    <little-header></little-header>
    <!--    <div class="shareImg position-fixed cursor-pointer">
          <img @click="onShare" src="/static/img/pro/share.png" alt="" class="">
        </div>-->

    <van-overlay :show="isShowCC" v-if="currentAdvSub.helpVideo">
      <div class="course-shaded position-relative">
        <div class="course-div" v-if="currentAdvSub.helpVideoResource && currentAdvSub.helpVideoResource.url">
          <iframe class="w-100 h-100" :src="'/static/videott/index1.html?vid='+currentAdvSub.helpVideoResource.url"/>
        </div>
        <img class="closeCC-btn position-absolute" @click="closeVideo"
             src="/static/img/pro/close.png">
      </div>
    </van-overlay>

    <adv-banner :currentAdvSub=currentAdvSub :isEndding=isEndding type="adv"
                @showCC="getShowCC"></adv-banner>
    <div class="pro-nav justify-content-center align-items-center" v-if="scrollTag">
      <div class="w-100 d-flex justify-content-around align-items-center">
        <a class="pro-nav-a p-home-a" href="#">项目</a>
        <a class="pro-nav-a p-story-a" v-if="storyContent" :class="{active: navClass==='p-story'}" href="#p-story-1">详情</a>
        <a class="pro-nav-a p-ke-a" v-if="currentAdvSub.courseList && currentAdvSub.courseList.length > 0" :class="{active: navClass==='p-ke'}" href="#p-ke-1">课程</a>
        <a class="pro-nav-a p-kao-a"  v-if="currentAdvSub.assessmentDesc" :class="{active: navClass==='p-kao'}" href="#p-kao-1">考核</a>
        <a class="pro-nav-a p-zj-a" v-if="currentAdvSub.leaderList && currentAdvSub.leaderList.length>0"
           :class="{active: navClass==='p-zj'}" href="#p-zj-1">师资</a>
        <a class="pro-nav-a p-zz-a" v-if="currentAdvSub.hasCertificate && currentAdvSub.certificate" :class="{active: navClass==='p-zz'}" href="#p-zz-1">证书</a>
      </div>
    </div>
    <adv-story v-if="storyContent" :story="storyContent"></adv-story>
    <adv-course v-if="currentAdvSub.courseList && currentAdvSub.courseList.length > 0" :advSub=currentAdvSub></adv-course>
    <adv-kao v-if="currentAdvSub.assessmentDesc" :checkContent="currentAdvSub.assessmentDesc"></adv-kao>
    <adv-expert v-if="currentAdvSub.leaderList && currentAdvSub.leaderList.length > 0" :advSubLecturers=currentAdvSub.leaderList></adv-expert>
    <adv-zi-zhi v-if="currentAdvSub.hasCertificate && currentAdvSub.certificate" :zizhiObj="currentAdvSub"></adv-zi-zhi>
    <little-footer class="mb-5"></little-footer>
    <foot-price :item="currentAdvSub" :userState="userState"></foot-price>
  </div>
</template>
<script>
  import advBanner from '@/page/subject/components/advBanner'
  import advStory from '@/page/subject/components/advStory'
  import advCourse from '@/page/subject/components/advCourse'
  import advKao from '@/page/subject/components/advKao'
  import advExpert from '@/page/subject/components/advExpert'
  import advZiZhi from '@/page/subject/components/advZiZhi'
  import FootPrice from '@/page/subject/components/footPrice'
  import littleFooter from '@/page/lecturer/components/littleFooter';
  import LittleHeader from "@/components/littleHeader";

  import Vue from 'vue';
  import {NavBar} from 'vant';
  import {Tabbar, TabbarItem} from 'vant';
  import {Icon} from 'vant';

  import {NoticeBar} from 'vant';
  import {Overlay} from 'vant';


  Vue.use(Overlay);
  Vue.use(NoticeBar);
  Vue.use(Icon);
  Vue.use(Tabbar);
  Vue.use(TabbarItem);
  Vue.use(NavBar);

  export default {
    name: "subjectAdvance",
    components: {
      LittleHeader,
      advBanner,
      advStory,
      advCourse,
      advKao,
      advExpert,
      advZiZhi,
      FootPrice,
      littleFooter,
    },
    data() {
      return {
        active: 0,
        userState: '',
        scrollTag: false,
        navClass: '',
        advSubCourse: [],
        advSubLecturers: [],
        showShare: false,
        shareObj: {},
        projectId: '',
        currentAdvSub: {},
        price: 0,
        totalCoursePrice: 0,
        isShowCC: false,
        timeType: 'singUp',
        isEndding: false,
        storyContent: ''
      }
    },

    mounted() {
      this.projectId = this.$route.params['id'];
      this.scrollFun();
      this.getProject();
    },
    methods: {
      getShowCC(e) {
        this.isShowCC = e;
      },
      closeVideo() {
        this.isShowCC = false;
        //关闭时暂停视频播放---调用一下腾讯云视频暂停事件
      },

      getProject() {
        this.$store.dispatch('getProjectForLearner', {id: this.projectId}).then((res) => {
          this.currentAdvSub = res;
          sessionStorage.setItem("currentProject", JSON.stringify(this.currentAdvSub));
          this.calcProject();
        })
      },
      calcProject() {
        if (this.currentAdvSub && this.currentAdvSub.id) {
          // 详情
          if(this.currentAdvSub.detail) {
            this.$store.dispatch('getContent', {content: this.currentAdvSub.detail}).then((res) => {
              this.storyContent = res;
            }, (error) => {
              this.storyContent = ''
            })
          }


        //计算必选课程的费用
          if (this.currentAdvSub.courseList && this.currentAdvSub.courseList.length > 0) {
          for (let v of this.currentAdvSub.courseList) {
            if (v.mustSelected) {
              this.totalCoursePrice += v.price;
            }
          }
        }
        let currentDate = new Date().getTime();
          //计算众筹时间是否结束
          let crowdEndTime = this.currentAdvSub.crowdFundingEndTime;
          if (currentDate >= crowdEndTime) {
            this.isEndding = true;
          } else {
            this.isEndding = false
          }
        let signUpStartTime = this.currentAdvSub.signUpStartTime;
        let signUpEndTime = this.currentAdvSub.signUpEndTime;

        let startTime = this.currentAdvSub.startTime;
        let endTime = this.currentAdvSub.endTime;
          //自主报名自己可以报名，非自主项目由管理员给报名，自己不能报名，可以激活
          if (!this.currentAdvSub.signUp) {
            if (!this.currentAdvSub.userProject) {
              this.userState = '';
            } else {
              this.timeType = 'jihuo';
              if (currentDate >= startTime && currentDate <= endTime) {
                this.userState = 'joinedGo'; //已经报名，这个点可以去激活了 ---报名成功，激活项目
                this.price = this.currentAdvSub.entryCost;
              } else if (currentDate >= signUpStartTime && currentDate < startTime) {
                this.userState = 'joinedWait'; //只是报名，未到激活的时间点 ---报名成功, 未到激活时间
                this.price = this.currentAdvSub.entryCost;
              } else if (currentDate > endTime) {
                this.userState = 'missActive'; //错过激活时间
              } else {
                this.userState = '';
              }
            }
          } else {
            if (!this.currentAdvSub.userProject) {
              this.timeType = 'signUp';

              if (currentDate >= startTime && currentDate <= signUpEndTime) {
                this.userState = 'joinActive';  //已经到既可以报名也可以激活 的时间段了---报名并激活
                this.price = this.totalCoursePrice + this.currentAdvSub.projectCost;
              } else if (currentDate >= signUpStartTime && currentDate < startTime) {
                this.userState = 'notJoin'; // 报名开始 但未进入激活时间---只能报名
                this.price = this.currentAdvSub.entryCost;
              } else {
                this.userState = 'missSign'; // 错过了报名时间---报名结束
              }
            } else {
              this.timeType = 'jihuo';
              if (currentDate >= startTime && currentDate <= endTime) {
                this.userState = 'joinedGo'; //已经报名，这个点可以去激活了 ---报名成功，激活项目
                this.price = this.currentAdvSub.entryCost;
              } else {
                this.userState = 'joinedWait'; //只是报名，未到激活的时间点 ---报名成功, 未到激活时间
                this.price = this.currentAdvSub.entryCost;
              }
          }
        }


        }

      },
      scrollFun() {
        let _this = this;
        let h11 = $('.pro-nav').height() + 10;
        $('.h11').css('top', -h11 + 'px');

        window.addEventListener('scroll', () => {
          let top = document.documentElement.scrollTop || document.body.scrollTop || window.pageYOffset
          if (top > $('.pro-banner').height() - 150) {
            _this.scrollTag = true;
          } else {
            _this.scrollTag = false
          }

          let stroyH = $('#p-story')[0]?$('#p-story')[0].offsetTop:0;
          let keH = $('#p-ke')[0]?$('#p-ke')[0].offsetTop:0;
          let kaoH = $('#p-kao')[0]?$('#p-kao')[0].offsetTop:0;
          let zjH = $('#p-zj')[0]?$('#p-zj')[0].offsetTop:0;
          let zzH = $('#p-zz')[0]?$('#p-zz')[0].offsetTop:0;

          if(zzH >0 && top >= zzH-100) {
            _this.navClass = 'p-zz';
          }else if(zjH >0 && top >= zjH-100) {
            _this.navClass = 'p-zj';
          }else if(kaoH >0 && top >= kaoH-100) {
            _this.navClass = 'p-kao';
          }else if(keH >0 && top >= keH-100) {
            _this.navClass = 'p-ke';
          }else if(stroyH>0 && top >= stroyH-100) {
            _this.navClass = 'p-story';
          }

        })
      },
      // onShare() {
      //   //把生成海报需要的信息传入cookie
      //
      //   this.shareObj = this.currentAdvSub;
      //   this.shareObj.qrcodeUrl = window.location.href;
      //   this.shareObj.fromPageType = 'project';
      //   localStorage.setItem('share_obj', JSON.stringify(this.shareObj))
      //   this.$router.push('/share-poster');
      // },

    }
  }
</script>

<style>

</style>
